"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ReactDateTime = require("react-datetime");
const React = require("react");
const Field = require("./formField");
const format = require("../format");
const text_1 = require("./text");
const hour_1 = require("./hour");
/**Selector de fecha y hora */
class DateTime extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.handleChange = (value) => {
            if (!this.props.onChange)
                return;
            if (!value)
                this.props.onChange(null);
            if (typeof (value) == "string") {
            }
            else {
                this.props.onChange(value.toDate());
            }
        };
        this.handleHourChange = (horas, minutos) => {
            if (!this.props.onChange)
                return;
            var horatomada = parseInt(horas);
            if (horas.length > 2) {
                var nuevahora = horas.substring(0, 2);
                horatomada = parseInt(nuevahora);
            }
            var minutotomado = parseInt(minutos);
            if (minutos.length > 2) {
                var nuevosminutos = minutos.substring(0, 2);
                minutotomado = parseInt(nuevosminutos);
            }
            const date = this.dateValue;
            if (!date)
                this.props.onChange(null);
            else if (horatomada != null && minutotomado != null) {
                const hours = Math.floor(horatomada || 0);
                const minutes = Math.floor(minutotomado || 0);
                var h = hours >= 24 ? 23 : hours;
                var m = minutes >= 60 ? 59 : minutes;
                const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), h, m);
                this.props.onChange(newDate);
            }
        };
    }
    get dateValue() {
        const origValue = this.props.value;
        const value = origValue == null ? null :
            typeof (origValue) == "string" ? new Date(origValue) : origValue;
        return value;
    }
    render() {
        const value = this.dateValue;
        const hours = value && value.getHours() + "" || "";
        const minutes = value && value.getMinutes() + "" || "";
        return (React.createElement(Field.FormField, { label: this.props.label, error: this.props.error }, React.createElement("div", { style: { display: "flex" } },
            React.createElement("div", { style: { flex: "1 0 0" } }, this.props.readonly ?
                React.createElement(text_1.Text, { value: (this.props.value ? format.formatDate(this.props.value) : "Sin fecha"), readonly: true }) :
                React.createElement(ReactDateTime, { locale: "es", value: value || undefined, onChange: this.handleChange, dateFormat: "DD/MM/YYYY", closeOnSelect: true, timeFormat: false })),
            this.props.time &&
                React.createElement("div", { style: { flex: "1 0 0" } },
                    React.createElement(hour_1.HourMinuteComponent, { min: 0, max: 24, hours: hours + "", minutes: minutes + "", onChange: x => this.handleHourChange(x.hours, x.minutes), readonly: this.props.readonly })))));
    }
}
exports.DateTime = DateTime;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/fields/datetime.js
// module id = 2207
// module chunks = 0